import script from "./AcademicSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./AcademicSidebar.vue?vue&type=script&setup=true&lang=ts"

import "./AcademicSidebar.vue?vue&type=style&index=0&id=2edf498f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2edf498f"]])

export default __exports__